const constants = {
  primaryColorClass: "gray-700",
  darkPrimaryColorClass: "gray-800",
};

export default constants;
